module.exports = __webpack_public_path__ + "static/media/empty.0bd7c7f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/empty.svg
// module id = 821
// module chunks = 0